export default function Header() {
  return (
    <header>
      {/* make logo and make all link */}
      <a href="/"><h1 className="logo">DinSexolog.dk</h1></a> 
    </header>
  );
}